"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "belmonte-in-sabina": {
    "d714ba9e": [{
      "hkey": "800b1ccc",
      "slug": "belmonte-in-sabina",
      "name": "Belmonte in Sabina",
      "primary": true,
      "skipSearch": false
    }],
    "localita-bivio-parigi": [{
      "hkey": "800b1ccc",
      "slug": "belmonte-in-sabina",
      "name": "Belmonte in Sabina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d7369301": [{
      "hkey": "800b1ccc",
      "slug": "belmonte-in-sabina",
      "name": "Belmonte in Sabina",
      "primary": true,
      "skipSearch": false
    }],
    "localita-cava": [{
      "hkey": "800b1ccc",
      "slug": "belmonte-in-sabina",
      "name": "Belmonte in Sabina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "50a71a01": [{
      "hkey": "800b1ccc",
      "slug": "belmonte-in-sabina",
      "name": "Belmonte in Sabina",
      "primary": true,
      "skipSearch": false
    }],
    "localita-san-nicola": [{
      "hkey": "800b1ccc",
      "slug": "belmonte-in-sabina",
      "name": "Belmonte in Sabina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bfa9166a": [{
      "hkey": "800b1ccc",
      "slug": "belmonte-in-sabina",
      "name": "Belmonte in Sabina",
      "primary": true,
      "skipSearch": false
    }],
    "localita-sant-elena": [{
      "hkey": "800b1ccc",
      "slug": "belmonte-in-sabina",
      "name": "Belmonte in Sabina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9a6958f1": [{
      "hkey": "800b1ccc",
      "slug": "belmonte-in-sabina",
      "name": "Belmonte in Sabina",
      "primary": true,
      "skipSearch": false
    }],
    "localita-turano": [{
      "hkey": "800b1ccc",
      "slug": "belmonte-in-sabina",
      "name": "Belmonte in Sabina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "81eb8009": [{
      "hkey": "800b1ccc",
      "slug": "belmonte-in-sabina",
      "name": "Belmonte in Sabina",
      "primary": true,
      "skipSearch": false
    }],
    "localita-zoccani": [{
      "hkey": "800b1ccc",
      "slug": "belmonte-in-sabina",
      "name": "Belmonte in Sabina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;